<div class="qBank dialog-wrapper">
  <div class="modal-header">
    <h5 class="modal-title">Associate Evaluator</h5>
    <button
      type="button"
      (click)="closeModal()"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="px-5 py-3 batch-evaluation">
    <div class="dialog-body">
      <div class="mt-2">
        <div class="GR-18">Batch Name : {{ data.stageTitle }}</div>
        <div class="GR-18 mt-2">Candidate Name : {{ data.candidateName }}</div>
        <!-- <span class="GR-18 text-wrap mt-3 ml-3">
          Batch Name : {{ data.stageTitle }}
        </span> -->

        <hr class="custom-horizontal-line" />

        @if(evaluators.length>0){
        <table class="table table-bordered table-striped my-4">
          <thead>
            <tr>
              <th style="width: 100px">
                <!-- <input
              type="checkbox"
              [(ngModel)]="allSelected"
              (change)="toggleAll()"
            /> -->
              </th>
              <th>Evaluator Name</th>
              <th>Candidate Evaluation Stats</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let item of evaluators; let i = index">
              <td>
                <input
                  type="radio"
                  [checked]="evaluatorSelected == item.userId"
                  (click)="toggleSelection(item)"
                />
              </td>
              <td>{{ item.name }}</td>
              <td>
                <div>
                  <span>
                    Pending:
                    <span class="text-warning batch-stats">
                      {{
                        item.evaluatorRoleMeta.associatedCandidateCount -
                          item.evaluatorRoleMeta.completedEvaluationFor
                      }}</span
                    >

                    |
                  </span>
                  <span>
                    Evaluated:
                    <span style="color: rgb(14, 194, 208)" class="batch-stats">
                      {{ item.evaluatorRoleMeta.completedEvaluationFor }}
                    </span>
                  </span>
                  |

                  <span>
                    Max Limit:
                    <span class="text-primary batch-stats">
                      {{ item.evaluatorRoleMeta.maxCandidateLimit }}
                    </span>
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        }
      </div>
    </div>
  </div>

  @if(evaluators.length > 0){
  <div class="dialog-footer text-center my-4">
    <button
      (click)="associateEvaluator()"
      type="button"
      class="btn btn-primary"
      data-dismiss="modal"
    >
      Assign Evaluator
    </button>
    <button
      (click)="closeModal()"
      type="button"
      class="btn btn-cancel"
      data-dismiss="modal"
    >
      Cancel
    </button>
  </div>
  }
</div>
